import { ApiError } from '../types/error'

export function errorToMessage(error: unknown, defaultMessage?: string): string {
  if (error instanceof ApiError) {
    const title = error.error.source?.pointer || error.error.source?.header || error.error.source?.parameter
    if (title) {
      return `${title} : ${error.error.detail}`
    }
    else {
      return error.error.detail ?? defaultMessage ?? '未知错误'
    }
  }
  else if (error instanceof Error) {
    return error.message
  }
  return String(error || defaultMessage || '未知错误')
}
